export default __webpack_public_path__ + "target-upload.svg";